/* =========================================================
   JP: Seal Subscriptions — show original one-time price
   inside Subscribe & save row (crossed out).
   Robust: watches Seal DOM for rerenders.
   FIXED: safe insertion (no insertBefore parent mismatch)
   ========================================================= */

(function () {
  const DEBUG = true;
  const LOG = "[JP Seal Compare]";
  const log = (...a) => DEBUG && console.log(LOG, ...a);

  const SELECTORS = {
    root: ".sealsubs-container",
    subRow: '.sls-option-container[data-selling-plan-group="0"]',
    oneTimeRow: '.sls-option-container [data-one-time-option-radio]',
    oneTimeMoney: ".sls-one-time-price .money",
    subMoney: '.sls-selling-plan-group-price .money',
  };

  function text(el) {
    return (el?.textContent || "").trim();
  }

  function findRoot() {
    return document.querySelector(SELECTORS.root);
  }

  function ensureCompareSpan(nextToMoneyEl) {
    // we insert our compare span next to the money element (same parent)
    const parent = nextToMoneyEl?.parentElement;
    if (!parent) return null;

    let compare = parent.querySelector(".jp-sls-compare");
    if (!compare) {
      compare = document.createElement("span");
      compare.className = "jp-sls-compare money";
      // safest: prepend inside the money wrapper
      parent.prepend(compare);
      log("Inserted compare span ✅");
    }
    return compare;
  }

  function updateOnce() {
    const root = findRoot();
    if (!root) return false;

    const subRow = root.querySelector(SELECTORS.subRow);
    const oneTimeRow = root.querySelector(SELECTORS.oneTimeRow)?.closest(".sls-option-container");
    if (!subRow || !oneTimeRow) return false;

    const original = text(oneTimeRow.querySelector(SELECTORS.oneTimeMoney));
    if (!original) return false;

    const subMoneyEl = subRow.querySelector(SELECTORS.subMoney);
    if (!subMoneyEl) return false;

    const compareEl = ensureCompareSpan(subMoneyEl);
    if (!compareEl) return false;

    if (compareEl.textContent !== original) {
      compareEl.textContent = original;
      log("Updated compare price ->", original);
    }

    return true;
  }

  // debounce
  let timer = null;
  function schedule(ms = 80) {
    clearTimeout(timer);
    timer = setTimeout(() => updateOnce(), ms);
  }

  function attachObservers() {
    const root = findRoot();
    if (!root) return false;

    const mo = new MutationObserver(() => schedule(80));
    mo.observe(root, { childList: true, subtree: true, attributes: true });

    // also handle full replacement
    const bodyMo = new MutationObserver(() => schedule(120));
    bodyMo.observe(document.body, { childList: true, subtree: true });

    log("Observers attached ✅");
    schedule(50);
    return true;
  }

  document.addEventListener("DOMContentLoaded", () => {
    log("Loaded ✅");

    // retry until Seal exists
    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      if (attachObservers() || tries > 40) clearInterval(iv);
    }, 250);

    document.addEventListener("change", () => schedule(120));
    document.addEventListener("click", () => schedule(180));
  });
})();